import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.onsend',
    component: Settings,
    path: '/modules/onsend',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
